import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import { RawHTML } from "@wordpress/element";

export default function save({ attributes }) {
	const {
		slidesPerView,
		slidesPerViewMobile,
		slidesPerViewTablet,
		spaceBetween,
		speed,
		autoplay,
		showPagination,
		carouselHeight,
		arrowBgColor,
		arrowIconColor,
		arrowIconSize,
		arrowBgSize,
		prevIconSVG,
		nextIconSVG,
		iconRadius,
	} = attributes;

	const blockProps = useBlockProps.save({
		className: `content-slider swiper-container`,
		style: { height: `${carouselHeight}px` },
		"data-slides": slidesPerView,
		"data-slides-mobile": slidesPerViewMobile,
		"data-slides-tablet": slidesPerViewTablet,
		"data-space-between": spaceBetween,
		"data-speed": speed,
		"data-autoplay": autoplay ? "true" : "false",
		"data-pagination": showPagination ? "true" : "false",
	});

	// Define styles for the navigation buttons and icons
	const arrowStyles = {
		backgroundColor: arrowBgColor,
		width: `${arrowBgSize}px`,
		height: `${arrowBgSize}px`,
		borderRadius: `${iconRadius}px`,
	};

	const iconStyles = {
		color: arrowIconColor,
		fontSize: `${arrowIconSize}px`,
	};

	return (
		<div {...blockProps}>
			<div className="swiper-wrapper">
				{/* This will render the saved content of all slides */}
				<InnerBlocks.Content />
			</div>
			<div className="swiper-button-prev" style={arrowStyles}>
				<span className="swiper-button-icon" style={iconStyles}>
					<RawHTML>{prevIconSVG}</RawHTML>
				</span>
			</div>
			{/* Apply styles and render custom icon */}
			<div className="swiper-button-next" style={arrowStyles}>
				<span className="swiper-button-icon" style={iconStyles}>
					<RawHTML>{nextIconSVG}</RawHTML>
				</span>
			</div>
			{showPagination && <div className="swiper-pagination"></div>}
		</div>
	);
}
